import { useEffect, useRef, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import MobileHeader from "../../layout/AuthLayout/MobileHeader";
import AuthFooter from "../../layout/AuthLayout/Footer";
import ArrowTickLeft from "../../../media/images/icons/arrow-tick-left";

export default function NotifsPage() {
  const divRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);

  const theme = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return (
    <>
      <MobileHeader hasScroll={hasScroll}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: "secondary.main",
              fontWeight: 700,
              fontSize: "16px",
            }}
          >
            کارن ترابر نت
          </Typography>
          <ArrowTickLeft color={theme.palette.textColor.main} size={14} />
          <Typography
            sx={{
              color: "secondary.main",
              fontSize: "14px",
              fontWeight: 700,
            }}
          >
            اعلان ها
          </Typography>
        </Box>
      </MobileHeader>

      <Box
        ref={divRef}
        sx={{
          // minWidth: "480px",
          maxWidth: "600px",
          width: {
            xs: "100%",
          },
          marginX: "auto",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          paddingX: "8px",
          paddingTop: "20px",
          overflow: "hidden",
        }}
      >
        <Outlet />

        <AuthFooter />
      </Box>
    </>
  );
}
